<template>
    <div class="ex-info">
        <div>
            <template v-if="list && list.length">
                <div class="my-item3">
                    <Row :gutter="30">
                        <Col span="8" v-for="(item, index) in list" :key="'my-item3' + index">
                        <div class="my-item3-box">
                            <div class="item-show" v-if="!item.isShow">
                                <i class="icon iconfont icon-hide"></i>
                            </div>
                            <div class="mi-content">
                                <div class="mi-content-top">
                                    <div class="mi-content-top-left">
                                        <img :src="item.headImg" class="logo" />
                                        <p class="txt" :title="item.name">{{ item.name }} <span
                                                style="font-size: 14px;"> {{ item.jobTitle }}</span></p>
                                        <p class="txt" :title="item.phone">{{ item.phone }}</p>
                                    </div>
                                    <div class="mi-content-top-right" v-if="item.publishType">
                                        <div class="brand" style="color:#fe8737">{{ item.publishType }} </div>
                                    </div>
                                </div>
                                <div class="mi-content-date">
                                    <Row :gutter="30">
                                        <Col span="12">
                                        <div class="left f-tal" v-if="item.publishType != '招商发布'">采购截止日期：{{
                                            item.endTime
                                            }}</div>
                                        <div class="left f-tal" v-if="item.publishType == '招商发布'">{{ item.inDate }}
                                        </div>
                                        </Col>
                                        <Col span="12">
                                        <!-- <span class="rn-type" v-if="item.productType" -->
                                        <span class="rn-type"
                                            style="color:#9a9de3;max-width: 180px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                            <span v-if="item.publishType != '招商发布'">{{ item.productType }}</span>
                                            <span v-if="item.publishType == '招商发布'">{{
                                                item.supplyProductCategory
                                                }}</span>
                                        </span>
                                        </Col>
                                    </Row>
                                </div>
                                <div v-if="item.publishType != '招商发布'">
                                    <div class="c-dy-r-content" style="padding: 25rpx;font-size: 26rpx;">
                                        <div>
                                            <div style="word-break: break-word;" v-if="item.remark">
                                                <!-- {{ item.remark }} -->

                                                <Tooltip max-width="400" :content="item.remark" theme="light">
                                                    <Button type="text" style="word-break: break-word;">{{
                                                        item.remark.slice(0, 20)
                                                        }}
                                                        <span v-if="item.remark.length >= 20">...</span>
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                            <div class="disFlex marTop15 ">
                                                <p class="divWidth color9">采购数量：</p>
                                                <p> {{ item.needCount }}</p>
                                            </div>
                                            <div class="disFlex marTop15 " v-if="item.publishType == '医疗器械成品'">
                                                <p class="divWidth color9">交货区域：</p>
                                                <p> {{ item.productArea }}</p>
                                            </div>
                                            <div class="disFlex marTop15 " v-if="item.publishType == '制造供应链'">
                                                <p class="divWidth color9">供应商所在地：</p>
                                                <p> {{ item.productArea }}</p>
                                            </div>
                                            <div class="disFlex marTop15 ">
                                                <p class="divWidth color9">资质要求：</p>
                                                <p> {{ item.condition }}</p>
                                            </div>
                                            <div class="disFlex marTop15 " v-if="item.publishType == '制造供应链'">
                                                <p class="divWidth color9">经验要求：</p>
                                                <p> {{ item.experience }}</p>
                                            </div>
                                            <div class="disFlex marTop15 " v-if="item.publishType == '制造供应链'">
                                                <p class="divWidth color9">支付要求：</p>
                                                <p> {{ item.payType }}</p>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- <p >来源：供需【{{item.sourceName}}】</p> -->
                                    <!-- <p class="color9">来源：{{ item.companyName }}</p> -->
                                    <div style="border: 0.5px #e5e5e5 dashed;width: 100%;margin: 20rpx 0;"></div>

                                    <div class="daili">
                                        <span class="span2">
                                            <span class="color9">来源：</span>
                                            {{ item.companyName ? item.companyName : item.companyName }}
                                        </span>
                                    </div>
                                </div>
                                <!-- 招商发布 -->
                                <div class="item" v-if="item.publishType == '招商发布'" @click="linkToChanceDetails(item)"
                                    style="padding-bottom: 15rpx;">
                                    <div class="item_bottom" style="font-size: 26rpx;">
                                        <div class="daili marTop15">
                                            <span class="span1">
                                                <span class="color9">招商类别：</span>
                                                {{ item.idnentityType ? item.idnentityType : '无' }}
                                            </span>
                                        </div>
                                        <div class="daili marTop15">
                                            <span class="span1">
                                                <span class="color9">招商产品：</span>
                                                <span v-if="item.fromType==0"> {{ item.supplyProductName ?
                                                    item.supplyProductName : '无' }}</span>
                                                <span v-else> {{ item.personProdcutName ? item.personProdcutName : '无'
                                                    }}</span>
                                            </span>
                                        </div>
                                        <div class="daili marTop15" v-if="item.fromType == 0">
                                            <span class="span2">
                                                <span class="color9">招商地区：</span>
                                                {{ item.productArea ? item.productArea : '无' }}

                                            </span>
                                        </div>
                                        <div class="daili marTop15" v-if="item.fromType == 1">
                                            <span class="span2">
                                                <span class="color9">产品简介：</span>
                                                <!-- <Tooltip :content="item.personProductIntroduction"
                                                    placement="top-start">
                                                    <span class="shenglue">{{ item.personProductIntroduction }}</span>
                                                </Tooltip> -->
                                                {{ item.personProductIntroduction ? item.personProductIntroduction : '无'
                                                }}

                                            </span>
                                        </div>
                                        <div class="daili marTop15">
                                            <span class="span2">
                                                <span class="color9">供应周期：</span>
                                                {{ item.supplyDate ? item.supplyDate : '无' }}
                                            </span>
                                        </div>
                                        <div class="daili marTop15">
                                            <span class="span2">
                                                <span class="color9">供应数量：</span>
                                                {{ item.supplyCount ? item.supplyCount : '无' }}
                                            </span>
                                        </div>

                                        <div style="border: 0.5px #e5e5e5 dashed;width: 100%;margin: 20rpx 0;"></div>

                                        <div class="daili">
                                            <span class="span2">
                                                <span class="color9">来源：</span>
                                                {{ item.fromCompany ? item.fromCompany : item.companyName }}
                                            </span>
                                        </div>
                                    </div>

                                </div>

                                <!-- <div class="mi-content-imglist" v-if="item.photo && item.photo.length">
                                    <img class="img-item" :src="i" v-for="(i, idx) in item.photo" v-if="idx < 3"
                                        :key="'img-item' + idx" />
                                </div> -->
                                <div class="mi-content-txt" v-if="item.information">
                                    <!-- {{ item.information }} -->
                                    <Tooltip max-width="400" :content="item.information" theme="light">
                                        <Button type="text" style="word-break: break-word;">{{
                                            item.information.slice(0, 20)
                                            }}
                                            <span v-if="item.information.length >= 20">...</span>
                                        </Button>
                                    </Tooltip>
                                </div>
                            </div>
                            <div class="mi-tool">
                                <div class="mi-tool-item"
                                    v-if="$route.query.type == '审核通过' || $route.query.type == '全部'"
                                    style="cursor:no-drop">处理
                                </div>
                                <div class="mi-tool-item" @click="rejectP(item)" v-else>处理</div>
                                <div class="mi-tool-line">|</div>
                                <!-- <div class="mi-tool-item" @click="setTopic(item)">推荐</div>
                  <div class="mi-tool-line">|</div> -->
                                <div class="mi-tool-item">
                                    <Dropdown trigger="custom" :visible="item.visible">
                                        <a href="javascript:void(0)" style="color:#808080;" @click="toggleOpen(index)">
                                            更多
                                            <Icon type="ios-arrow-down"></Icon>
                                        </a>
                                        <DropdownMenu slot="list" style="text-align:center;">
                                            <DropdownItem v-if="item.isShow" @click.native="showOff(item)">屏蔽
                                            </DropdownItem>
                                            <DropdownItem v-else @click.native="showOn(item)">显示</DropdownItem>
                                            <DropdownItem>
                                                <Poptip confirm placement="top-start" title="确认删除此条数据吗 ?"
                                                    @on-ok="delItem(item, index)" @on-cancel="handleClose(index)">
                                                    <div style="width: 100px;">删除</div>
                                                </Poptip>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                        </Col>
                    </Row>
                </div>
                <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;padding: 20ppx;">
                    <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
                        @on-change="changePage" @on-page-size-change="changePageSize" />
                </div>
            </template>
            <div class="u-empty" v-else style="margin: 30px;">暂无数据</div>
        </div>


        <iModal :title="modelTitle" v-model="rejectModel" class-name="vertical-center-modal" width="600px"
            :mask-closable="false">

            <!-- <Input v-model="rejectValue" type="textarea" :rows="4" placeholder="请输入..."></Input> -->
            <div>您确定要审核通过吗</div>

            <div slot="footer">
                <Button type="primary" @click="changeHandle()">确定</Button>
                <Button @click="rejectModel = false">取消</Button>
            </div>
        </iModal>

    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "supply-user-info-all",
    props: {
        status: {
            type: String,
            default: "1"
        }
    },
    data () {
        return {

            rejectModel: false,
            rejectValue: "",
            modelTitle: "",
            rowUser: {},


            editTopic: false,
            editTopicnfo: null,

            list: null,
            pageSize: 12,
            list2: [],
            pageIndex: 1,
            totalCount: 0,
            text: ''
        };
    },
    created () {
        this.init();
    },
    watch: {
        status (val, oldVal) {
            this.init();
        }
    },
    computed: {
        option () {
            let statusId=null;
            if (this.$route.query.type == '待审核'){
                statusId=0
            }
            if (this.$route.query.type == '审核通过'){
                statusId=1
            }
            return {
                // ExhibitionId: this.exhibitionInfo.id,
                PageSize: this.pageSize,
                PageIndex: this.pageIndex,
                isSearchAll: false,
                statusId: statusId,
                Wheres: {
                    type: 0,
                    wheres: {
                        WhereGroupOperator: 0,
                        Predicates: [
                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 0,
                                    Label: 'PublishType',
                                    Value: '招商发布',
                                },
                            },
                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 6,
                                    Label: 'name',
                                    Value: `%${this.text}%`,
                                },
                            },
                        ],
                    },
                },
            };
        },
        exhibitionInfo () {
            if (JSON.parse(localStorage.vuex)) {
                return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
            }
        }
    },
    methods: {
        ...mapActions({
            getReleaseType: "momentModule/getReleaseType",
            getReleaseByExhibition: "releaseModule/getReleaseByExhibition",
            getAllReleaseAndSupply: "releaseModule/getAllReleaseAndSupply",
            deleteNewRealease: "releaseModule/deleteNewRealease",
            deleteReleaseRelevancy: "releaseModule/deleteReleaseRelevancy",
            delRelease: "releaseModule/delRelease",
            editReleaseStatus: "releaseModule/editReleaseStatus",
            editReleaseShow: "releaseModule/editReleaseShow",
            editReleaseHandle: "releaseModule/editReleaseHandle",
            editNewRealeaseAuditReleaseHandle: "releaseModule/editNewRealeaseAuditReleaseHandle",

            
        }),
        setTopic (item) {
            // 设置置顶
            this.editTopicnfo = item;
            this.editTopic = true;
        },



        async init () {
            let listData = await this.getReleaseType(this.exhibitionInfo.id);
            if (listData && listData.length) {
                this.list2 = listData;
            }
            let exData = await this.getAllReleaseAndSupply(this.option);
            //   if (exData) {
            //     exData.items.map(c => {
            //       if (c.typeInfo) c.typeInfo = JSON.parse(c.typeInfo);
            //       if (c.photo && c.photo.indexOf("[") !== -1)
            //         c.photo = JSON.parse(c.photo);
            //       this.list2.forEach(v => {
            //         if (v.id === c.typeId) {
            //           c.brand = v;
            //         }
            //       });
            //       c.visible = false;
            //     });
            //     this.list = exData;
            exData.items.forEach((e) => {
                e.visible = false;
                e.inTime = e.inTime.substring(0, 10)
                e.inDate = e.inDate.substring(0, 10)
                e.endTime = e.endTime ? e.endTime.substring(0, 10) : ''
                if (e.productArea) {
                    e.productArea = (JSON.parse(e.productArea).toString()).replace(/,/g, '/')
                }


                const categoryArr = []
                const categoryArr1 = []

                if (e.productType) {
                    const category = JSON.parse(e.productType)
                    if (category.Value) {
                        categoryArr.push(category.Value)
                        if (category.List[0]) {
                            categoryArr.push(category.List[0].Value)
                            if (category.List[0].List) {
                                categoryArr.push(category.List[0].List[0].Value)
                            }
                        }
                        e.productType = (categoryArr.toString()).replace(/,/g, '/')
                    }
                }
                if (e.supplyProductCategory) {
                    const category1 = JSON.parse(e.supplyProductCategory)
                    if (category1.Value) {
                        categoryArr1.push(category1.Value)
                        if (category1.List[0]) {
                            categoryArr1.push(category1.List[0].Value)
                            if (category1.List[0].List) {
                                categoryArr1.push(category1.List[0].List[0].Value)
                            }
                        }
                        e.supplyProductCategory = (categoryArr1.toString()).replace(/,/g, '/')
                    }
                }

                console.log(categoryArr.toString(), typeof categoryArr.toString())
            })
            this.list = exData.items
            console.log(this.list, '00000000000000000000000000000000000000')
            this.pageSize = exData.pageSize;
            this.pageIndex = exData.pageIndex;
            this.totalCount = exData.totalCount;
            //   }
        },
        // 修改展品显示、屏蔽
        async showOff (item) {
           
            let result = await this.editReleaseShow({ id: item.id, bool: false });
            if (result.successed) {
                this.$Message.success("修改成功");
                this.init();
            } else {
                this.$Message.error("修改失败，请重新尝试");
            }
        },
        async showOn (item) {
            let result = await this.editReleaseShow({ id: item.id, bool: true });
            if (result.successed) {
                this.$Message.success("修改成功");
                this.init();
            } else {
                this.$Message.error("修改失败，请重新尝试");
            }
        },
        async delItem (item, index) {
            // this.$Message.warning("暂未启用");
            // return
            let result = await this.deleteReleaseRelevancy(item.id);
            if (result.successed) {
                this.$Message.success("删除成功");
                this.init();
            } else {
                this.$Message.error("删除失败，请重新尝试");
            }
            this.handleOpen(index);
        },
        async changeStatus (item) {
            const req = {
                Id: item.id,
                StatusId: "1"
            };
            let result = await this.editReleaseStatus(req);
            if (result.successed) {
                this.$Message.success("操作成功");
                this.init();
            } else {
                this.$Message.error("操作失败，请重新尝试");
            }
        },


        rejectP (row, index) {
            this.rejectValue = ''
            this.rowUser = row
            this.modelTitle = '请填写处理原因：'
            this.rejectModel = true
        },

        async changeHandle () {
            // let result = await this.editReleaseHandle(item.id);
            let opt = {
                id: this.rowUser.id,
                statusId:1,
                remark: this.rejectValue,

            }
            let result = await this.editNewRealeaseAuditReleaseHandle(opt);
            if (result.successed) {
                this.rejectModel = false
                this.$Message.success("操作成功");
                this.init();
            } else {
                this.$Message.error("操作失败，请重新尝试");
            }
        },
        changePage (e) {
            this.pageIndex = e;
            this.init();
        },
        changePageSize (pageSize) {
            this.pageSize = pageSize;
            this.init();
        },

        handleOpen (index) {
            this.list[index].visible = true;
        },
        handleClose (index) {
            this.list[index].visible = false;
        },
        toggleOpen (index) {
            let visible = this.list[index].visible;
            this.list[index].visible = !visible;
        }
    },
    destroyed () {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
};
</script>

<style scoped lang="scss">
.ex-info {
    &-top {
        width: 100%;
        min-height: 100px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        padding: 20px 24px 0 36px;

        &-l {
            height: 100%;
            display: flex;
            flex-direction: column;

            .s1 {
                flex: 1;
                font-size: 14px;
                color: #8c8c8c;
            }

            .h1 {
                flex: 1;
                font-size: 18px;
                color: #333;
                font-weight: bold;
            }

            .s2 {
                flex: 1;
                font-size: 14px;
                color: #333;
            }
        }

        &-r {
            &-box {
                width: 150px;
                height: 80px;
                border: 1px dashed #1890ff;
                background-color: #e7f4ff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                .I1 {
                    font-size: 16px;
                    font-weight: bold;
                    color: #1890ff;
                }

                .s3 {
                    font-size: 14px;
                    color: #1890ff;
                    margin-left: 9px;
                }
            }
        }
    }

    &-content {
        min-width: 1000px;
        padding: 30px;
        padding-bottom: 50px;
    }

    &-list {
        width: 100%;
        display: inline-block;
        background-color: #fff;
        margin-bottom: 30px;

        &-img {
            width: 100%;
            padding-bottom: 66.666667%;
            position: relative;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                max-width: 100%;
                max-height: 100%;
            }
        }

        &-title {
            padding-left: 10px;
            font-size: 14px;
            color: #1a1a1a;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 31px;
            background: #fff;
            height: 66px;
            padding: 10px 10px 7px 12px;
        }

        &-time {
            width: 300px;
            min-height: 27px;
            padding-left: 10px;
            font-size: 14px;
            color: #fe791e;
        }
    }
}

.pro {
    &-tool {
        display: flex;
        height: 48px;
        align-items: center;
        justify-content: space-around;
        background-color: #f7f9fa;

        &-item {
            flex: 1;
            line-height: 48px;
            font-size: 14px;
            color: #808080;
            cursor: pointer;
            text-align: center;

            &:hover {
                color: #1890ff;
            }

            &.z-del {
                &:hover {
                    color: #f00;
                }
            }
        }

        &-line {
            background-color: #e8e8e8;
            font-size: 20px;
            width: 1px;
            height: 22px;
        }
    }
}

.rn-type {
    display: inline-block;
    font-size: 18rpx;
    padding: 0rpx 5rpx;
    line-height: 30rpx;
    margin-right: 12rpx;
    margin-bottom: 12rpx;
    border-width: 1px;
    border-style: solid;
}

.rn-type {
    display: inline-block;
    font-size: 18rpx;
    padding: 0rpx 5rpx;
    line-height: 30rpx;
    margin-right: 12rpx;
    position: relative;
    top: -4rpx;
    border-width: 1px;
    border-style: solid;
}

.mybutton2 {
    // width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 55px;
    background: none;
    padding: 0;
    color: #adadad;
    font-size: 10px;
    position: relative;
    top: 6px;
}

.mybutton2::after {
    border: none;
}

.button1 {
    width: 446rpx;
    height: 84rpx;
    background-color: #ff5d00;
    border-radius: 10rpx;
    border: solid 1px #ff5d00;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        color: #fff;
        font-size: 36rpx;
    }
}

.button2 {
    width: 446rpx;
    height: 84rpx;
    border-radius: 10rpx;
    border: solid 1px #ff5d00;
    margin-top: 40rpx;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        color: #fe5502;
        font-size: 36rpx;
    }
}

/deep/ ._van-popup {
    .van-center-enter-active {
        border-radius: 8rpx;
    }
}

.cate {
    width: 96rpx;
    height: 64rpx;
    border-radius: 10rpx;
    border: solid 1rpx #ccc;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        color: #666;
    }
}

.s-cate {
    width: 96rpx;
    height: 64rpx;
    background-color: #936dd8;
    border-radius: 10rpx;
    border: solid 1rpx #936dd8;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        color: #fff;
    }
}

.place-holder {
    color: #666;
    font-size: 26rpx;
    padding: 20rpx 20rpx 20rpx 20rpx;
    height: 220rpx;
    width: 90%;
}

.textareaDiv {
    height: 240rpx;
    border-radius: 10rpx;
    border: solid 1rpx #ccc;
    margin-top: 30rpx;
}

.color9 {
    color: #999999;
}

// .rn-type {
//   display: inline-block;
//   font-size: 18rpx;
//   padding: 0rpx 5rpx;
//   line-height: 30rpx;
//   margin-right: 12rpx;
//   margin-bottom: 12rpx;
//   border-width: 1px;
//   border-style: solid;
// }
.disFlex {
    display: flex;
}

.marTop15 {
    margin-top: 15rpx;
}

.divWidth {
    width: 30%;
}

.shenglue{
    display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
}
</style>
